window.sumZero = window.sumZero || {};

sumZero.tinyNotifier = {

  open($div) {
    $div = $div || $('.tiny-notification').first();
    $div.addClass('is-open');
    return $div.slideDown();
  },

  close($div) {
    $div = $div || $('.tiny-notification').first();
    $div.removeClass('is-open');
    return $div.slideUp();
  },

  toggle($div) {
    $div = $div || $('.tiny-notification').first();
    if ($div.hasClass('is-open')) { return sumZero.tinyNotifier.close($div); } else { return sumZero.tinyNotifier.open($div); }
  }
};

const pairs = (obj) => Object.keys(obj).map(key => [key, obj[key]]);

class NotificationMessages {

  constructor() {
    this.cleanOldNotifications = this.cleanOldNotifications.bind(this);
  }

  init() {
    this.suppressNotification();
    this.setNotificationsData();
    this.cleanOldNotifications();
    return window.setTimeout(
      () => this.displayNotifications()
    , 2000);
  }

  setNotificationsData() {
    this.templates = {
      default: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
      dark: '<div class="popover popover--dark" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
    };

    //
    // All content/display data for the various notifications should go here
    // as nested objects. Each object's key should have the same name as the
    // value passed in on your [data-notification-key] attribute in the DOM
    // and should start with "notification_"
    //

    return this.notificationsData = {
      notification_fund_profile_admin: {
        title: 'Profile Administration',
        content: 'Use this link to edit your fund profile or view how your profile appears to different types of users.',
        placement: 'left'
      },
      notification_save_search: {
        title: 'Save Search Parameters',
        content: 'Save your search parameters and you will be notified anytime a member posts an idea that meets all of the parameters you specify. <br><br><button class="button--major" data-notification-close="notification_save_search">OK</button>',
        placement: 'bottom',
        html: true,
        close: 'clickOn'
      },
      notification_follow_fund: {
        title: 'Follow Funds to Get Updates',
        content: 'Follow this fund to receive updates in your Activity Feed when the firm updates performance details, adds new docs, or posts new research ideas.<br><br><button class="button--primary" data-notification-close="notification_create_idea_pdf">Got it</button>',
        placement: 'right',
        html: true,
        close: 'clickOnPlusElement',
        theme: this.templates.dark
      }
    };
  }

  suppressNotification() {
    if ($('#allocator_profile_card').length || $('#cap_intro_tab').hasClass('active')) {
      return window.localStorage.setItem("notification_cap_intro", "closed");
    }
  }

  displayNotifications() {
    // Split into key / value pairs
    return pairs(this.notificationsData).forEach(pair => {
      let key = pair[0];
      let properties = pair[1];
      if ((this.oldKeys.indexOf(key) === -1) &&  // Make sure this isn't an expired key
      (window.localStorage.getItem(key) !== "closed") && // Make sure the user hasn't dismissed this already
      $(`[data-notification-key=${key}]`).length) {
        if (properties.prerequisite && (window.localStorage.getItem(properties.prerequisite) !== 'closed')) { return; }

        let $area = $(`[data-notification-key=${key}]`);
        if (properties.isModal) {
          $area.modal({show: true, keyboard: false, backdrop: 'static'});
          $area.find(`[data-notification-close=${key}]`).on('click', function(event) {
            $area.modal('hide');
            return window.localStorage.setItem(key, 'closed');
          });
          return;
        }


        // If we have multiple instances of the same notification on the page,
        // check for the priority attribute to determine which gets the
        // notification.

        if ($area.length > 1) {
          if ($(`[data-notification-key=${key}][data-notification-priority]`).length) {
            $area = $(`[data-notification-key=${key}][data-notification-priority=\"true\"]`);
          } else {
            $area = $(`[data-notification-key=${key}]`).first();
          }
        }

        if (!$area.is(":visible")) { return; }

        let attachNotification = function() {
          if (properties.container) { properties.container = $area.parent(); }
          return window.setTimeout(function() {
            $area.popover({
              template: properties.theme || '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
              title: properties.title || '',
              content: properties.content || '',
              placement: properties.placement || 'left',
              trigger: 'manual',
              container: properties.container || 'body',
              html: properties.html || false
            });

            $area.on('shown.bs.popover', function(event) {

              let $closingElement;
              if (properties.plain) { $area.data('bs.popover').$tip.addClass('popover-plainStyle'); }

              if (properties.close === 'clickOn') {
                $closingElement = $(event.target).data('bs.popover').$tip.find("[data-notification-close]");
              } else if (properties.close === 'clickOnPlusElement') {
                $closingElement = $(event.target).data('bs.popover').$tip.find("[data-notification-close]");
                $.merge($closingElement, $area);
              } else {
                $closingElement = $('html');
              }
              return $closingElement.on('click', function() {
                $area.popover('hide');
                return window.localStorage.setItem(key, 'closed');
              });
            });
            $area.popover('show');

            return $area.on('remove', function() {
              $area.popover('hide');
              return window.localStorage.setItem(key, 'closed');
            });
          }
          , 500);
        };

        if (properties.scroll) {
          return $area.one('inview', attachNotification);
        } else {
          return attachNotification();
        }
      }
    });
  }

  cleanOldNotifications() {
    // This removes any expired notifications.
    this.oldKeys = ['notification_analyst_rankings', 'notification_market_cap', 'notification_volume', 'notification_request_idea_update', 'notification_anonymous_commenting'];
    let today = new Date();
    let pairsList = pairs(this.notificationsData); // Split into key name: [0] and object: [1]
    pairsList.forEach(item => {
      if (item[1].expires < today) { return this.oldKeys.push(item[0]); }
    });

    return (this.oldKeys).forEach(key => window.localStorage.removeItem(key));
  }
};

const notificationMessages = new NotificationMessages();
$(function(){
  notificationMessages.init();
})
